import api from './api'

export const tasksApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/tasks', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/tasks/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/tasks', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/tasks/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/tasks/${id}`),
  getForEdit: (id: number | string): Promise<any> => api.get(`/tasks/${id}/edit`),
  getCreateData: (): Promise<any> => api.get('/tasks/create'),
}

export default tasksApi
